"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailsView = exports.ContentView = exports.SplitView = void 0;
// external
const React = require("react");
const react_1 = require("react");
// local
const screenBreakpoints_1 = require("../../../../helpers/screenBreakpoints");
const layouts_1 = require("../../../../types/layouts");
// css
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "SplitView");
/**
 * Component that renders a relational split content/details view
 */
const SplitView = ({ children, className }) => {
    return (React.createElement("div", { className: css("", { className }), "data-test": "split-view" }, children));
};
exports.SplitView = SplitView;
const ContentView = ({ alignment = layouts_1.THorizontalPositions.Left, children, className }) => {
    return (React.createElement("div", { className: css("content", `-align-${alignment}`, { className }), "data-test": "content-view", "data-alignment": alignment }, children));
};
exports.ContentView = ContentView;
const DetailsView = ({ children, size = "md", sticky = true, className }) => {
    const [width, setWidth] = (0, react_1.useState)(window.innerWidth);
    // HACK - base on the size of the SplitView instead
    (0, react_1.useEffect)(() => {
        const updateWidth = () => {
            setWidth(window.innerWidth);
        };
        window.addEventListener("resize", updateWidth);
        return () => {
            window.removeEventListener("resize", updateWidth);
        };
    }, []);
    if (width < screenBreakpoints_1.breakpoints.sm) {
        return children;
    }
    const classNames = css("details", `-size-${size}`, {
        "-isSticky": sticky,
        className
    });
    return (React.createElement("div", { className: classNames, "data-test": "details-view", "data-size": size, "data-fixed": "false" }, children));
};
exports.DetailsView = DetailsView;
//# sourceMappingURL=index.js.map